module.exports = __webpack_public_path__ + "img/tshirt2.604c95e7.jpg";